import React, { useEffect, useState } from 'react';
import {
  Button,
  useTranslate,
  required,
  NumberInput,
  SelectInput,
  useDataProvider,
} from 'react-admin';
import {
  Edit as IconContentEdit,
  Close as CloseIcon,
} from '@material-ui/icons';
import { Dialog, DialogTitle, Grid, IconButton } from '@material-ui/core';
import { linkButton } from 'styles';
import { BaseForm } from '../../Components';
import { nonNegativeInt, validateFolderNumber } from '../../utils/validation';

const resource = 'plotEvidence';
const nonNegativeIntValidation = [required(), nonNegativeInt];
const folderNumberValidation = [required(), validateFolderNumber];
const PlotEvidenceQuickEditButton = (props) => {
  const [showDialog, setShowDialog] = useState(false);
  const translate = useTranslate();
  const buttonClasses = linkButton();

  const [evidences, setEvidences] = useState([]);
  const dataProvider = useDataProvider();

  // Need to get the choices here as well as PlotForm component slightly different because of the SelectionInput
  useEffect(() => {
    dataProvider
      .getList('evidence', { filter: { plotId: props.record.plotId } })
      .then(({ data }) => {
        const evidenceArray = data.map(({ id, name }) => ({ id, name }));
        setEvidences(evidenceArray);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const handleClick = () => {
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };

  return (
    <>
      <Button
        className={buttonClasses.root}
        onClick={handleClick}
        label="ra.action.edit"
      >
        <IconContentEdit />
      </Button>
      <Dialog
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
        aria-label={`Edit ${resource}`}
      >
        <DialogTitle>
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
          >
            {translate(`resources.${resource}.titles.edit`)}
            <IconButton aria-label="close" onClick={handleCloseClick}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </DialogTitle>
        <BaseForm {...props} resource={resource}>
          <SelectInput
            source="evidenceId.id"
            label="Evidence Name"
            choices={evidences}
            validate={required()}
          />
          <NumberInput
            source="folderNumber"
            validate={validateFolderNumber}
          />
          <NumberInput
            source="orderIndex"
            validate={nonNegativeIntValidation}
          />
          <NumberInput
            source="requiredActors"
            validate={nonNegativeIntValidation}
          />
        </BaseForm>
      </Dialog>
    </>
  );
};

export default PlotEvidenceQuickEditButton;
